function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.3967 13.84C14.0681 12.5328 15.1431 10.4971 15.1431 8.21139C15.1431 4.26675 11.9556 1.07568 8.01099 1.07032C4.06099 1.06496 0.857422 4.26318 0.857422 8.21139C0.857422 10.4471 1.88421 12.4417 3.49314 13.7507C3.55564 13.8007 3.64671 13.79 3.69671 13.7275L4.40028 12.8257C4.44849 12.765 4.43778 12.6775 4.37885 12.6275C4.23421 12.5096 4.09492 12.3828 3.96099 12.2489C3.43889 11.7286 3.02284 11.1118 2.73599 10.4328C2.43599 9.73104 2.28599 8.98282 2.28599 8.21139C2.28599 7.43996 2.43599 6.69175 2.73421 5.98818C3.02171 5.30782 3.43421 4.69711 3.95921 4.17211C4.48421 3.64711 5.09492 3.23461 5.77528 2.94711C6.48064 2.64889 7.22885 2.49889 8.00028 2.49889C8.77171 2.49889 9.51992 2.64889 10.2235 2.94711C10.9039 3.23461 11.5146 3.64711 12.0396 4.17211C12.5646 4.69711 12.9771 5.30782 13.2646 5.98818C13.5628 6.69175 13.7128 7.43996 13.7128 8.21139C13.7128 8.98282 13.5628 9.73104 13.2646 10.4346C12.9777 11.1136 12.5617 11.7304 12.0396 12.2507C11.8735 12.4167 11.6985 12.5721 11.5164 12.715L10.7896 11.7846C10.7731 11.7633 10.751 11.7471 10.7257 11.7379C10.7005 11.7286 10.6731 11.7267 10.6468 11.7323C10.6205 11.7379 10.5964 11.7508 10.5771 11.7695C10.5578 11.7883 10.5441 11.8121 10.5378 11.8382L9.83064 14.7346C9.80921 14.8239 9.87707 14.9114 9.96814 14.9114L12.9503 14.9257C13.0699 14.9257 13.1378 14.7882 13.0628 14.6953L12.3967 13.84Z",
    fill: "#485365",
    style: {
      fill: "#485365",
      fill: "color(display-p3 0.2824 0.3255 0.3961)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedoIcon);
export default __webpack_public_path__ + "static/media/redo-icon.6b450abfc0eed0f7665334e24b3b8e43.svg";
export { ForwardRef as ReactComponent };